/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload())

      // Fixed background to force user to update
      const fixedBg = document.createElement('div')
      fixedBg.setAttribute('style', `
        position: fixed;
        z-index: 100;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0);
        transition: background-color 1s;
      `)

      // Create "please refresh" button
      const refreshDiv = document.createElement('div')
      refreshDiv.setAttribute('style', `
        position: fixed;
        z-index: 200;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid black;
        padding: 5px 15px;
        border-radius: 7px;
        background-color: #0c2556;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: top 1s, opacity 1s;
        opacity: 0;
      `)
      refreshDiv.innerHTML = 'App has been updated! Please refresh to continue using Moonpull: '

      const refreshButton = document.createElement('button')
      refreshButton.style.marginLeft = '10px'
      refreshButton.classList.add('btn', 'btn-secondary')
      refreshButton.innerHTML = 'Refresh'
      refreshButton.addEventListener('click', () => {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
      })
      refreshDiv.appendChild(refreshButton)
      fixedBg.appendChild(refreshDiv)
      document.body.appendChild(fixedBg)
      setTimeout(() => {
        refreshDiv.style.top = '20px'
        refreshDiv.style.opacity = '1'
        fixedBg.style.backgroundColor = 'rgba(0,0,0,0.5)'
      }, 500)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
